import { VALUE_CHAIN_AI_AGENT } from 'constants/general';

import type { IAICardSelection } from 'components/AICardPanel/interfaces/IAICardSelection';

export const normalizeUnitIds = (unitIds: number[]): number[] => (
  Array.from(new Set(unitIds))
    .filter((unitId) => Number.isInteger(unitId))
    .sort((leftUnitId, rightUnitId) => leftUnitId - rightUnitId)
);

export const getUnitIdFromNodeId = (nodeId: string): number | null => {
  const [, rawUnitId = ''] = nodeId.split('unit_');
  const parsedUnitId = Number(rawUnitId);

  return Number.isInteger(parsedUnitId) ? parsedUnitId : null;
};

export const areUnitIdsEqual = (
  leftUnitIds: number[],
  rightUnitIds: number[],
): boolean => (
  leftUnitIds.length === rightUnitIds.length
  && leftUnitIds.every((unitId, index) => unitId === rightUnitIds[index])
);

export const extractSelectedUnitIdsFromCards = (
  selectedCards: IAICardSelection[],
): number[] => normalizeUnitIds(
  selectedCards.reduce<number[]>((unitIds, card) => {
    const parsedUnitId = getUnitIdFromNodeId(card.nodeId);
    if (parsedUnitId === null) {
      return unitIds;
    }

    unitIds.push(parsedUnitId);
    return unitIds;
  }, []),
);

export const filterSelectedCardsBySearch = (
  selectedCards: IAICardSelection[],
  search: string,
): IAICardSelection[] => {
  const normalizedSearch = search.trim().toLowerCase();
  if (!normalizedSearch) {
    return selectedCards;
  }

  return selectedCards.filter((card) => card.name.toLowerCase().includes(normalizedSearch));
};

export const isSearchSubTypeBlockedByExistingSession = (
  nextSubType: string,
  isBillOfMaterialsSession: boolean,
  isSupplierDiscoverySession: boolean,
): boolean => (
  (nextSubType === VALUE_CHAIN_AI_AGENT.SUPPLIER_DISCOVERY_SESSION_TYPE && isBillOfMaterialsSession)
  || (nextSubType === VALUE_CHAIN_AI_AGENT.BILL_OF_MATERIALS_SESSION_TYPE && isSupplierDiscoverySession)
);

export const canPersistAgentSessionUnitSelection = (sessionStatus?: string): boolean => (
  !sessionStatus
  || sessionStatus === VALUE_CHAIN_AI_AGENT.STATUS_UNIT_SELECTION
);
